(function () {
  'use strict';

  angular
    .module('module.modal-controllers', [])

    /* @ngInject */
    .controller('modalCtrl', ["data", "device", "options", "$scope", function (data, device, options, $scope) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      ctrl.showLoader = true;
      $scope.device = device;

      ctrl.onLoad = function () {
        ctrl.showLoader = false;
      };
    }])

    /* @ngInject */
    .controller('modalSendByEMailCtrl', ["data", "device", "options", "HttpService", "AppService", "ModalService", "toastr", function (data, device, options, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;

      ctrl.data = data;
      ctrl.data.Message = '';
      ctrl.data.Recipients = [{}];
      ctrl.modalTitle = options.modalTitle;

      ctrl.addRecipient = function () {
        ctrl.data.Recipients.push({});
      };
      ctrl.removeRecipient = function (index) {
        ctrl.data.Recipients.splice(index, 1);
      };

      AppService.getParams()
        .then(function (params) {
          if (params.IsLogged) {
            ctrl.data.Email = params.Visitor.Email;
            ctrl.data.FirstName = params.Visitor.FirstName;
            ctrl.data.LastName = params.Visitor.LastName;
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      ctrl.submit = function () {
        ctrl.loading = true;

        HttpService.post({
          url: '/SendByEmail',
          data: ctrl.data
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                ModalService.close();
                toastr.success('', options.resultMessage, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.loading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

    }])

    /* @ngInject */
    .controller('modalAddToCartCtrl', ["data", "device", "options", "$scope", function (data, device, options, $scope) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      $scope.device = device;

      if (ctrl.data.length === 1) {
        ctrl.suggestionsUrl = 'Template/Modal/ModalAddToCartSuggestions?' + (new Date().getTime());
      }

    }]);

})();
